// src/components/HeroSection.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();
  return (
    <section className="min-h-screen bg-gray-900 text-white font-sans flex items-center relative overflow-hidden pt-24 lg:pt-24">
      {/* Background Image */}
      <div className="absolute inset-0 overflow-hidden opacity-50 xl:opacity-70">
        <img
          src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          alt="Riff Raff Tech Solutions Background"
          className="w-full h-full object-cover object-left lg:object-left lg:scale-110 transition-all duration-700"
        />
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 max-w-4xl mt-10 px-6 md:px-12 lg:px-24">
        {/* Tagline */}
        <div className="flex flex-col lg:flex-row items-center lg:items-start justify-center lg:justify-start space-y-3 lg:space-y-0 lg:space-x-4 mb-6">
          <span className="bg-white text-gray-900 text-xs font-semibold px-3 py-2 rounded-xl tracking-wider">
            Build & Innovate
          </span>
          <p className="text-gray-300 text-sm max-w-md lg:max-w-full">
            Empowering businesses with cutting-edge web & app solutions
          </p>
        </div>

        {/* Heading */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-light leading-snug mb-8 text-center lg:text-left">
          Riff Raff Tech Solutions <br />
          Crafting Scalable <br />
          Digital Experiences
        </h1>

        {/* Subtext */}
        <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto lg:mx-0 mb-12 leading-relaxed text-center lg:text-left">
          From intuitive websites to robust web applications, we help startups
          and enterprises bring ideas to life. Our team leverages modern
          technologies and proven strategies to deliver solutions that scale,
          perform, and transform businesses.
        </p>

        {/* Call to Action */}
        <div className="flex justify-center lg:justify-start">
          <button
            onClick={() => {
              navigate("/#contact");
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="flex items-center space-x-3 px-8 py-3 text-sm md:text-base font-medium border border-white rounded-lg hover:bg-white hover:text-gray-900 transition duration-300 group"
          >
            <span>Start Your Project</span>
            <svg
              className="w-4 h-4 transform group-hover:translate-x-1 transition duration-200"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              ></path>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
